import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = { class: "d-flex align-items-end gap-4" }
const _hoisted_5 = { class: "card-toolbar" }
const _hoisted_6 = { class: "card-body" }
const _hoisted_7 = { class: "table align-middle table-row-dashed fs-6 gy-5" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { key: 2 }

import { ref, inject, onMounted } from "vue";
import AccountService from "../services/AccountService";
import ChangeCreditForm from "@/projects/tenant/modules/Payment/components/ChangeCreditForm.vue";
import ChangeAdjustForm from "@/projects/tenant/modules/Payment/components/ChangeAdjustForm.vue";
import { AuditTypes } from "@/core/types/AuditTypes";
import AccountInjectionKeys from "@/projects/tenant/modules/accounts/types/AccountInjectionKeys";
import MsgPrompt from "@/core/plugins/MsgPrompt";


export default /*#__PURE__*/_defineComponent({
  __name: 'AccountDetailCredit',
  setup(__props) {

const accountDetails = inject(AccountInjectionKeys.ACCOUNT_DETAILS);
const changeCreditFormRef = ref<InstanceType<typeof ChangeCreditForm>>();
const changeAdjustFormRef = ref<InstanceType<typeof ChangeAdjustForm>>();

const isLoading = ref(false);
const data = ref(Array<any>());
const criteria = ref<any>({
  page: 1,
  size: 12,
  type: AuditTypes.TradeAccountBalance,
  accountNumber: accountDetails.value.accountNumber,
});

const creditTypes = [
  { label: "Credit", value: "Credit" },
  { label: "Adjust", value: "Balance" },
];

const reset = async () => {
  criteria.value.page = 1;
  criteria.value.size = 12;
  criteria.value.type = AuditTypes.TradeAccountBalance;
  criteria.value.accountNumber = accountDetails.value.accountNumber;
  criteria.value.adjustType = "";
  criteria.value.rowId = null;
  fetchData(1);
};

const fetchData = async (_page: number) => {
  criteria.value.page = _page;
  isLoading.value = true;
  try {
    const audit = await AccountService.getCreditList(criteria.value);
    criteria.value = audit.criteria;
    data.value = audit.data;
  } catch (error) {
    MsgPrompt.error(error);
  }
  isLoading.value = false;
};

const onEventSubmitted = () => {
  fetchData(1);
};
const openChangeCreditPanel = () => {
  changeCreditFormRef.value?.show(
    accountDetails.value.accountNumber,
    "hideLoginNo"
  );
};

const openChangeAdjustPanel = () => {
  changeAdjustFormRef.value?.show(
    accountDetails.value.accountNumber,
    "hideLoginNo"
  );
};
onMounted(() => {
  fetchData(1);
});

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_LoadingRing = _resolveComponent("LoadingRing")!
  const _component_NoDataBox = _resolveComponent("NoDataBox")!
  const _component_TimeShow = _resolveComponent("TimeShow")!
  const _component_BalanceShow = _resolveComponent("BalanceShow")!
  const _component_TableFooter = _resolveComponent("TableFooter")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", null, [
              _createVNode(_component_el_select, {
                modelValue: criteria.value.adjustType,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((criteria.value.adjustType) = $event)),
                clearable: "",
                placeholder: "Type"
              }, {
                default: _withCtx(() => [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(creditTypes, (item) => {
                    return _createVNode(_component_el_option, {
                      key: item.value,
                      label: item.label,
                      value: item.value
                    }, null, 8, ["label", "value"])
                  }), 64))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _createElementVNode("div", null, [
              _createVNode(_component_el_button, {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (fetchData(1))),
                type: "primary"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("action.search")), 1)
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", null, [
              _createVNode(_component_el_button, {
                onClick: reset,
                type: "info",
                plain: ""
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("action.reset")), 1)
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_el_button, {
            type: "success",
            onClick: openChangeCreditPanel
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("action.changeCredit")), 1)
            ]),
            _: 1
          }),
          (_ctx.$can('TenantAdmin'))
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                type: "success",
                onClick: openChangeAdjustPanel
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("action.changeAdjust")), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("table", _hoisted_7, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("td", null, _toDisplayString(_ctx.$t("fields.type")), 1),
              _createElementVNode("td", null, _toDisplayString(_ctx.$t("fields.ticket")), 1),
              _createElementVNode("td", null, _toDisplayString(_ctx.$t("fields.staff")), 1),
              _createElementVNode("td", null, _toDisplayString(_ctx.$t("fields.createdOn")), 1),
              _createElementVNode("td", null, _toDisplayString(_ctx.$t("fields.amount")), 1),
              _createElementVNode("td", null, _toDisplayString(_ctx.$t("fields.remark")), 1)
            ])
          ]),
          (isLoading.value)
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_8, [
                _createVNode(_component_LoadingRing)
              ]))
            : (!isLoading.value && data.value.length == 0)
              ? (_openBlock(), _createElementBlock("tbody", _hoisted_9, [
                  _createVNode(_component_NoDataBox)
                ]))
              : (_openBlock(), _createElementBlock("tbody", _hoisted_10, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value, (item, index) => {
                    return (_openBlock(), _createElementBlock("tr", { key: index }, [
                      _createElementVNode("td", null, _toDisplayString(item.data.adjustType === "Credit" ? "Credit" : "Adjust"), 1),
                      _createElementVNode("td", null, _toDisplayString(item.data.ticket), 1),
                      _createElementVNode("td", null, _toDisplayString((item.user.firstName + " " + item.user.lastName).trim() === ""
                  ? item.user.nativeName
                  : item.user.firstName + " " + item.user.lastName), 1),
                      _createElementVNode("td", null, [
                        _createVNode(_component_TimeShow, {
                          type: "inFields",
                          "date-iso-string": item.createdOn
                        }, null, 8, ["date-iso-string"])
                      ]),
                      _createElementVNode("td", null, [
                        _createVNode(_component_BalanceShow, {
                          balance: item.data.amount * 100,
                          "currency-id": item.account.currencyId
                        }, null, 8, ["balance", "currency-id"])
                      ]),
                      _createElementVNode("td", null, _toDisplayString(item.data.comment), 1)
                    ]))
                  }), 128))
                ]))
        ])
      ]),
      _createVNode(_component_TableFooter, {
        onPageChange: fetchData,
        criteria: criteria.value
      }, null, 8, ["criteria"])
    ]),
    _createVNode(ChangeCreditForm, {
      ref_key: "changeCreditFormRef",
      ref: changeCreditFormRef,
      onEventSubmit: onEventSubmitted
    }, null, 512),
    _createVNode(ChangeAdjustForm, {
      ref_key: "changeAdjustFormRef",
      ref: changeAdjustFormRef,
      onEventSubmit: onEventSubmitted
    }, null, 512)
  ], 64))
}
}

})